/**
 * Marketplace seed data — sample local service providers, grouped by
 * category and serviced city. Plain JS export so an operator can edit it
 * by hand without touching components.
 *
 * Replace every "Sample —" entry with a real vetted vendor as they're
 * sourced. Phone numbers and cities below are neutral placeholders and
 * should NOT be dialed.
 *
 * Shape per entry:
 *   { name, category, cities, phone, website?, notes? }
 *
 * Categories (canonical, must match Marketplace.js):
 *   - Electricians
 *   - Handymen
 *   - Gate Technicians
 *   - Fence Companies
 *   - Mowing / Landscape
 *   - Camera Technicians
 */

const marketplaceSeed = [
  // — Electricians ————————————————————————————————————————————————
  {
    name: 'Citywide Electric',
    category: 'Electricians',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0142',
    website: 'https://example.com/citywide-electric',
    notes: 'Sample — replace with real vendor. 24-hour emergency service.',
  },
  {
    name: 'Summit Power Solutions',
    category: 'Electricians',
    cities: ['Springfield', 'Riverside', 'Fairview'],
    phone: '(555) 555-0167',
    notes: 'Sample — replace with real vendor. Light-commercial certified.',
  },
  {
    name: 'Metro Electrical Co.',
    category: 'Electricians',
    cities: ['Lakewood'],
    phone: '(555) 555-0189',
    website: 'https://example.com/metro-electrical',
    notes: 'Sample — replace with real vendor. Same-day service available.',
  },

  // — Handymen ————————————————————————————————————————————————————
  {
    name: 'Hometown Handyman Services',
    category: 'Handymen',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0211',
    notes: 'Sample — replace with real vendor. General repairs, painting, door fixes.',
  },
  {
    name: 'Fairview Repair & Restore',
    category: 'Handymen',
    cities: ['Fairview'],
    phone: '(555) 555-0234',
    notes: 'Sample — replace with real vendor. Insured, no minimum job size.',
  },
  {
    name: 'Lakewood Property Helpers',
    category: 'Handymen',
    cities: ['Lakewood'],
    phone: '(555) 555-0256',
    website: 'https://example.com/lakewood-property-helpers',
    notes: 'Sample — replace with real vendor. Storage-facility experience.',
  },

  // — Gate Technicians ———————————————————————————————————————————
  {
    name: 'Springfield Gate Repair',
    category: 'Gate Technicians',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0312',
    notes: 'Sample — replace with real vendor. Access-control integration experience.',
  },
  {
    name: 'Fairview Automated Gates',
    category: 'Gate Technicians',
    cities: ['Fairview'],
    phone: '(555) 555-0345',
    website: 'https://example.com/fairview-gates',
    notes: 'Sample — replace with real vendor. Slide + swing gate service.',
  },
  {
    name: 'Lakewood Access Pros',
    category: 'Gate Technicians',
    cities: ['Lakewood'],
    phone: '(555) 555-0378',
    notes: 'Sample — replace with real vendor. Keypad and gate-controller familiarity.',
  },

  // — Fence Companies ————————————————————————————————————————————
  {
    name: 'Springfield Fence Builders',
    category: 'Fence Companies',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0421',
    website: 'https://example.com/springfield-fence',
    notes: 'Sample — replace with real vendor. Chain-link + cedar privacy.',
  },
  {
    name: 'Fairview Perimeter Co.',
    category: 'Fence Companies',
    cities: ['Fairview'],
    phone: '(555) 555-0445',
    notes: 'Sample — replace with real vendor. Commercial-grade fence repair.',
  },
  {
    name: 'Lakewood Commercial Fencing',
    category: 'Fence Companies',
    cities: ['Lakewood'],
    phone: '(555) 555-0468',
    notes: 'Sample — replace with real vendor. Same-day estimates.',
  },

  // — Mowing / Landscape ———————————————————————————————————————
  {
    name: 'Greenfield Lawn & Landscape',
    category: 'Mowing / Landscape',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0512',
    website: 'https://example.com/greenfield-lawn',
    notes: 'Sample — replace with real vendor. Weekly maintenance contracts.',
  },
  {
    name: 'Fairview Grounds Crew',
    category: 'Mowing / Landscape',
    cities: ['Fairview'],
    phone: '(555) 555-0534',
    notes: 'Sample — replace with real vendor. Mowing, edging, hedge trim.',
  },
  {
    name: 'Lakewood Greenscape',
    category: 'Mowing / Landscape',
    cities: ['Lakewood'],
    phone: '(555) 555-0567',
    notes: 'Sample — replace with real vendor. Commercial property focus.',
  },

  // — Camera Technicians ————————————————————————————————————————
  {
    name: 'Springfield Surveillance Pros',
    category: 'Camera Technicians',
    cities: ['Springfield', 'Riverside'],
    phone: '(555) 555-0612',
    website: 'https://example.com/springfield-surveillance',
    notes: 'Sample — replace with real vendor. IP cam installs, NVR config.',
  },
  {
    name: 'Fairview Camera Systems',
    category: 'Camera Technicians',
    cities: ['Fairview'],
    phone: '(555) 555-0645',
    notes: 'Sample — replace with real vendor. ONVIF-compatible installs.',
  },
  {
    name: 'Lakewood Security Vision',
    category: 'Camera Technicians',
    cities: ['Lakewood'],
    phone: '(555) 555-0678',
    website: 'https://example.com/lakewood-security-vision',
    notes: 'Sample — replace with real vendor. Cloud-recording integrations.',
  },
];

export default marketplaceSeed;
